module.exports = __webpack_public_path__ + "static/media/module_push.1c5cd269.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_push.png
// module id = ./src/resources/images/modules/module_push.png
// module chunks = 0